import css from './wordList.module.scss';

import { memo } from 'react';

import { FrameHeader } from 'core/ui/Frame';
import { Icon } from 'core/ui/icons';

import Filters from './Filters';
import List, { useWordList } from './List';

const WordList = () => {
  const listProps = useWordList();

  return (
    <div className={css.module}>
      <FrameHeader>
        <span className={css.deckNameLabel}>Cards in: </span>
        <span className={css.deckName}>
          {listProps.deck?.name || '…'} <Icon icon="Cards" />
        </span>
      </FrameHeader>

      {listProps.deck && (
        <Filters
          deck={listProps.deck}
          addWord={listProps.onAddWord}
          fetchInitial={listProps.fetchInitial}
          filters={listProps.filters}
          setFilter={listProps.setFilter}
        />
      )}

      <List
        fetchInitial={listProps.fetchInitial}
        fetchMore={listProps.fetchMore}
        words={listProps.words}
        filters={listProps.filters}
        setFilter={listProps.setFilter}
        isFetching={listProps.isFetching}
        deck={listProps.deck}
        deckUid={listProps.deckUid}
        onChangeWord={listProps.onChangeWord}
        onAddWord={listProps.onAddWord}
        onRemoveWord={listProps.onRemoveWord}
      />
    </div>
  );
};

export default memo(WordList);
